// extracted by mini-css-extract-plugin
export default {"textH2":"TextH2_textH2__0SHFe"};